import { EcardPreview } from './EcardPreview';
export default EcardPreview;
